import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Seo } from '../components/Seo'

export function NotFound() {
  const { t } = useTranslation()
  return (
    <main className="page container">
      <Seo title={t('seo.notFoundTitle')} description={t('notfound.desc')} path="/404" noIndex />
      <div className="card empty-state" style={{ maxWidth: 520, margin: '48px auto' }}>
        <div className="icon" aria-hidden="true">🧭</div>
        <h3>{t('notfound.title')}</h3>
        <p>{t('notfound.desc')}</p>
        <Link className="btn primary" to="/">
          {t('notfound.back')}
        </Link>
      </div>
    </main>
  )
}
